<template>
  <section class="pb-[60px] xl:pb-[140px]" id="start-today">
    <div class="container">
      <SectionTitle :title="$t('landing.start_steps.title')" />
      <div class="w-full flex flex-col lg:flex-row items-stretch gap-5">
        <CardStep
          v-for="(step, idx) of Steps"
          :key="idx"
          :id="step.id"
          :title="$t(step.title)"
          :description="$t(step.description)"
          :action="step.action"
          :image="step.image"
          :class="stepColors[step?.id]"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Steps } from "@/data/index";
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import CardStep from "@/modules/Landing/components/Card/Step.vue";
const stepColors = computed(() => {
  return {
    1: "gradient-second",
    2: "gradient-third",
    3: "gradient-first",
  };
});
</script>

<style scoped>
.gradient-first {
  background: linear-gradient(115.53deg, #edfaff 10.54%, #f0fff6 107.64%);
}
.gradient-second {
  background: linear-gradient(136.65deg, #fbfff0 -13.51%, #ebfff3 125.16%);
}
.gradient-third {
  background: linear-gradient(
    180deg,
    rgba(241, 255, 255, 0.95) -30.75%,
    #f8faee 108.22%
  );
}
</style>
